import Tooltip from '@atlaskit/tooltip';
import { SearchIcon } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';

import { dataTestIds } from '../constants';
import { IconButton } from './Button.styles';

export const Search = () => {
  const [isSearchSelected, setIsSearchSelected] = useState<boolean>(false);
  return (
    <Tooltip content="Search Marketplace">
      <IconButton
        role="button"
        aria-label="Search"
        isSelected={isSearchSelected}
        onClick={() => setIsSearchSelected(!isSearchSelected)}
        tabIndex={0}
        data-testId={dataTestIds.SEARCH}
      >
        <SearchIcon />
      </IconButton>
    </Tooltip>
  );
};
